import script from "./CommentsDrawResult.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentsDrawResult.vue?vue&type=script&setup=true&lang=js"

import "./CommentsDrawResult.vue?vue&type=style&index=0&id=d3a88066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3a88066"]])

export default __exports__